import { useMutation } from '@apollo/client/react';
import {
  UPDATE_CATALOG_ITEM,
  GET_VENDOR_CATALOG,
  MY_VENDOR_CATALOG_ITEM,
} from 'api/graphql/catalog';
import { useVendor } from 'features/vendor';

/**
 * Updates a catalog item and refreshes both the catalog list and the item.
 * Returns `updateCatalogItem(input)` resolving to the mutation payload.
 */
export function useUpdateCatalogItem(catalogId) {
  const { vendorId } = useVendor();

  const [mutate, { loading }] = useMutation(UPDATE_CATALOG_ITEM, {
    refetchQueries: [
      ...(vendorId ? [{ query: GET_VENDOR_CATALOG, variables: { vendorId } }] : []),
      ...(catalogId ? [{ query: MY_VENDOR_CATALOG_ITEM, variables: { catalogId } }] : []),
    ],
    awaitRefetchQueries: true,
  });

  const updateCatalogItem = async (input) => {
    const { data } = await mutate({
      variables: { catalogId, input: { ...input, vendorId } },
    });
    return data?.updateCatalogItem ?? null;
  };

  return { updateCatalogItem, loading };
}
